import { render, staticRenderFns } from "./x-money-input.vue?vue&type=template&id=7ad262da&"
import script from "./x-money-input.vue?vue&type=script&lang=ts&"
export * from "./x-money-input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports